import { observable } from 'mobx'

interface IData {
  id: number,
  short: string,
  name: string,
  rights: any[],
  color: string,
  urlLogin: string,
  urlSSO: string,
}

export default class ApplicationModel {
  store
  id = 0
  @observable short = ''
  @observable name = ''
  @observable rights = []
  @observable initialParams: string[] = []
  color = ''
  urlLogin = ''
  urlSSO = ''

  constructor(store: any, data: IData) {
    this.store = store
    this.id = data.id
    this.short = data.short
    this.name = data.name
    this.rights = data.rights
    this.color = data.color
    this.urlLogin = data.urlLogin
    this.urlSSO = data.urlSSO
  }

  destroy() {
    this.store.remove(this)
  }

  static fromJS(store, data: IData) {
    return new ApplicationModel(store, data)
  }
}
